import React from 'react';
import BtnPlus from '../../../button/btnPlus/BtnPlus';
import * as css from './TrialSendingPopup.css';

interface AddContactSectionProps {
    disabled: boolean;
    addText: string;
    onAddContact: () => void;
}

function AddContactSection({disabled, addText, onAddContact}: AddContactSectionProps) {
    return (
        <css.addInputSection $disabled={disabled}>
            <BtnPlus 
                hasText={false} 
                state={undefined} 
                onClick={onAddContact}
                white={undefined} 
                bsize={undefined} 
                dataCyName={'whatsapp-trial-add-phone'}
                text={''} 
                disabled={disabled} 
            />
            <css.addText>{addText}</css.addText>
        </css.addInputSection>
    );
}

export default AddContactSection;
